import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { DOCUMENT_CATEGORY_PREFIX_URL } from './constants/config.document-category'

const ListPage = lazy(() => import('./pages/ListPage.DocumentCategory'))

const DocumentCategoryRouters: AppRouterItem[] = [
  {
    path: `${DOCUMENT_CATEGORY_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
]

export default DocumentCategoryRouters
